import { commitMutation,
  graphql } from 'react-relay';
import environment from '../../.';
import { basicMutationOnCompleted, onErrorMutation } from '../common/common';

export const mutation = graphql`
mutation UpdateRolesMutation($userId: ID!, $roles: [UserRoleInput!]!) {
  updateRoles(userId: $userId, roles: $roles) {
    ok
    error
  }
}
`;

export default ({ userId, roles }, done) => {
  const variables = {
    userId,
    roles
  };

  commitMutation(
    environment(),
    {
      mutation,
      variables,
      onCompleted: ({ updateRoles }) => basicMutationOnCompleted(updateRoles, done),
      onError: error => onErrorMutation(error, done)
    }
  );
};
